"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _debouncePromise = _interopRequireDefault(require("debounce-promise"));
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
require("./styles.scss");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var searchIcon = /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
  icon: _freeSolidSvgIcons.faSearch,
  size: "1x"
});
var TableSearch = /*#__PURE__*/function (_Component, _serverSearchWrapper) {
  (0, _inherits2.default)(TableSearch, _Component);
  var _super = _createSuper(TableSearch);
  function TableSearch(props) {
    var _this;
    (0, _classCallCheck2.default)(this, TableSearch);
    _this = _super.call(this, props);
    _this.state = {
      value: props.inputValue || '',
      readOnly: true
    };
    _this.onValChange = _this.onValChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.search = _this.search.bind((0, _assertThisInitialized2.default)(_this));
    _this.prevalue = null;
    _this.keyCheck = _this.keyCheck.bind((0, _assertThisInitialized2.default)(_this));
    _this.debounceServerSearch = _this.debounceServerSearch.bind((0, _assertThisInitialized2.default)(_this))();
    _this.serverSearchWrapper = _this.serverSearchWrapper.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(TableSearch, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;
      var _this$props = this.props,
        data = _this$props.data,
        inputValue = _this$props.inputValue,
        serverSearch = _this$props.serverSearch,
        searchDataCallback = _this$props.searchDataCallback;
      if (!serverSearch) {
        var prevDataProps = prevProps.data || [];
        // this calls search again when DIFFERENT data is passed in to props, for updated results.
        var sortedPropsData = prevDataProps.sort();
        var sortedPrevPropsData = prevDataProps.sort();
        var samedata = prevDataProps.length === data.length && sortedPrevPropsData.every(function (value, index) {
          return value === sortedPropsData[index];
        });
        if (!samedata && searchDataCallback) {
          this.prevalue = null;
          this.search();
          this.prevalue = inputValue || this.state.value;
        }
        var setInputValue = function setInputValue() {
          if (inputValue && prevProps.inputValue !== inputValue) {
            _this2.setState({
              value: inputValue
            });
          }
        };
        setInputValue();
      }
    }
  }, {
    key: "onValChange",
    value: function onValChange(e) {
      this.setState({
        value: e.target.value
      });
    }
  }, {
    key: "debounceServerSearch",
    value: function debounceServerSearch() {
      var _this3 = this;
      return (0, _debouncePromise.default)(function () {
        return _this3.state.cancelDebounce ? false : _this3.serverSearchWrapper(_this3.state.value);
      }, 2000);
    }
  }, {
    key: "serverSearchWrapper",
    value: function serverSearchWrapper() {
      return (_serverSearchWrapper = _serverSearchWrapper || (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.setState({
                isLoading: true
              });
              _context.next = 3;
              return this.props.serverSearch(this.state.value);
            case 3:
              this.setState({
                isLoading: false
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }))).apply(this, arguments);
    }
  }, {
    key: "search",
    value: function search() {
      if (this.prevalue !== this.state.value) {
        var trimsearch = this.state.value.toString().trim().toLowerCase();
        var defaultKey = this.props.defaultSearchKey;
        var columns = this.props.columns;
        var filteredData = this.props.data;
        if (defaultKey !== '') {
          filteredData = this.props.data.filter(function (elem) {
            if (elem[defaultKey]) {
              return elem[defaultKey].toString().toLowerCase().includes(trimsearch);
            }
            return false;
          });
        } else {
          filteredData = this.props.data.filter(function (elem) {
            var ret = false;
            for (var i = 0; i < columns.length; i += 1) {
              if (columns[i] && elem[columns[i].key]) {
                ret = elem[columns[i].key].toString().toLowerCase().includes(trimsearch);
              }
              if (ret) {
                break;
              }
            }
            return ret;
          });
        }
        this.prevalue = this.state.value;
        this.props.searchDataCallback(filteredData, this.state.value);
      }
    }
  }, {
    key: "keyCheck",
    value: function keyCheck(event) {
      var _this4 = this;
      var elementClass = event.currentTarget.className;
      if (this.props.serverSearch && (event.key === 'Enter' || elementClass === 'clicksearch')) {
        this.setState({
          cancelDebounce: true,
          isLoading: true
        });
        this.serverSearchWrapper();
      } else if (this.props.serverSearch) {
        this.setState({
          cancelDebounce: false,
          isLoading: true
        }, function () {
          return _this4.debounceServerSearch();
        });
      } else {
        this.search();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      var onChangeCallback = this.props.onChangeCallback;
      var isLoading = this.state.isLoading;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "searchcontainer"
      }, /*#__PURE__*/_react.default.createElement("input", {
        className: "searchinput",
        type: "text",
        placeholder: this.props.placeholder,
        value: this.state.value,
        onKeyUp: this.keyCheck,
        disabled: !this.props.data,
        onChange: function onChange(e) {
          _this5.onValChange(e);
          onChangeCallback(e);
        },
        onFocus: function onFocus() {
          return _this5.setState({
            readOnly: false
          });
        },
        onBlur: function onBlur() {
          return _this5.setState({
            readOnly: true
          });
        },
        readOnly: this.state.readOnly
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "loading-indicator ".concat(isLoading ? 'is-loading' : '')
      }, /*#__PURE__*/_react.default.createElement("span", null), /*#__PURE__*/_react.default.createElement("span", null), /*#__PURE__*/_react.default.createElement("span", null)), /*#__PURE__*/_react.default.createElement("span", {
        className: "clicksearch",
        role: "button",
        tabIndex: 0,
        onClick: this.keyCheck,
        onKeyUp: this.serverSearchWrapper
      }, searchIcon));
    }
  }]);
  return TableSearch;
}(_react.Component);
TableSearch.propTypes = {
  columns: _propTypes.default.instanceOf(Array),
  data: _propTypes.default.instanceOf(Array),
  defaultSearchKey: _propTypes.default.string,
  inputValue: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  /** Callback to return filtered data */
  searchDataCallback: _propTypes.default.func,
  serverSearch: _propTypes.default.func,
  onChangeCallback: _propTypes.default.func
};
TableSearch.defaultProps = {
  columns: [],
  data: [],
  inputValue: null,
  placeholder: 'Search',
  defaultSearchKey: '',
  searchDataCallback: function searchDataCallback() {
    return null;
  },
  serverSearch: null,
  onChangeCallback: function onChangeCallback() {
    return null;
  }
};
var _default = TableSearch;
exports.default = _default;